import image from './add-to-the-call-tour.png'

export default (): React.ReactElement => <img width="100%" height="auto" src={image} alt="add to the call" />
